import { Component, Input, ElementRef, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import sparkline from '@fnando/sparkline';

@Component({
  selector: 'app-sparkline',
  templateUrl: './sparkline.component.html',
  styleUrls: ['./sparkline.component.less']
})
export class SparklineComponent implements AfterViewInit, OnChanges {
  @Input() data: Array<any>;
  @ViewChild('svg') svg: ElementRef;

  constructor() { }

  ngAfterViewInit() {
    this.drawLine();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.drawLine();
  }

  private drawLine() {
    sparkline(this.svg.nativeElement, this.data.map(item => item[1]));
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/sparkline/sparkline.component.ts